import { render, staticRenderFns } from "./layout-sider.vue?vue&type=template&id=6b6516d7"
import script from "./layout-sider.vue?vue&type=script&lang=js"
export * from "./layout-sider.vue?vue&type=script&lang=js"
import style0 from "./layout-sider.vue?vue&type=style&index=0&id=6b6516d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports